import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@core/auth/AuthProvider';
import { fetchRegularCompanions } from '../api/companions';
import type { RegularCompanion } from '../api/companions';

export function useRegularCompanions() {
  const { authState } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['regularCompanions'],
    queryFn: fetchRegularCompanions,
    enabled: !!authState.isAuthenticated,
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: data ?? [] as RegularCompanion[],
    isLoading,
  };
}
